import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.714,
			children: [/* @__PURE__ */ _jsx("path", { d: "M14.571 8.571a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428Zm-6.857 8.572a.857.857 0 1 0 0-1.714.857.857 0 0 0 0 1.714Zm0-6a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429Z" }), /* @__PURE__ */ _jsx("path", { d: "M16.32 21.052a1.715 1.715 0 0 0-1.114-1.51 3.429 3.429 0 0 1 1.08-6.685h3.205a3.428 3.428 0 0 0 3.24-4.577 11.143 11.143 0 1 0-10.508 14.863 10.802 10.802 0 0 0 2.983-.412 1.543 1.543 0 0 0 1.114-1.68Z" })]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0h24v24H0z",
				fill: "#fff"
			})
		}) })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.714%22%3E%3Cpath%20d%3D%22M14.571%208.571a1.714%201.714%200%201%200%200-3.428%201.714%201.714%200%200%200%200%203.428Zm-6.857%208.572a.857.857%200%201%200%200-1.714.857.857%200%200%200%200%201.714Zm0-6a1.714%201.714%200%201%200%200-3.429%201.714%201.714%200%200%200%200%203.429Z%22%2F%3E%3Cpath%20d%3D%22M16.32%2021.052a1.715%201.715%200%200%200-1.114-1.51%203.429%203.429%200%200%201%201.08-6.685h3.205a3.428%203.428%200%200%200%203.24-4.577%2011.143%2011.143%200%201%200-10.508%2014.863%2010.802%2010.802%200%200%200%202.983-.412%201.543%201.543%200%200%200%201.114-1.68Z%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22%23fff%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
